import React, { useEffect, useRef } from 'react';
import { Field, Form } from 'react-final-form';
import { SelectBrandsMultipleField } from '../form/SelectBrandsMultiple';
import SelectField from '../form/SelectField';
import { i18nMark, Trans } from '@lingui/react';
import TextareaField from '../form/TextareaField';
import SubmitButton from '../form/SubmitButton';
import { getFilterFromLocalStorage } from '../../utils/LocalStorageFilterUtils';
import { useSelector } from 'react-redux';
import { selectors as appSelectors } from '../../reducers/appReducer';
import { getBrandFilter } from '../../selectors/filterSelectors';

function validate(values, type) {
    const mandatoryFieldError = i18nMark('validation:error:mandatory:field');
    let errors = {};

    // console.log(values);

    if (!values.exchange_format) {
        errors.exchange_format = mandatoryFieldError;
    }

    if (type === 'Marca') {
        if (!values.brands || values.brands.length === 0) {
            errors.brands = mandatoryFieldError;
        }
    }

    if (type === 'Collezione') {
        if (!values.collection) {
            errors.collection = mandatoryFieldError;
        }
    }

    return errors;
}

const FormExportPanel = (props) => {

    const canLoadFiltersFromLocalStorage = useSelector(appSelectors.getLoadFiltersFromLocalStorage)
    const brandsInState = useSelector(getBrandFilter)

    // *** CARICAMENTO DAL LOCAL STORAGE *** //
    // Inizializza il ref con il valore corretto (non una funzione)
    const getInitialBrands = () => {
        if (canLoadFiltersFromLocalStorage) {
            const storedBrands = getFilterFromLocalStorage('sigle_marca');
            return storedBrands ? [...storedBrands] : [];
        } else {
            // brandsInState è un oggetto ImmutableJS, estraiamo i codici
            const brandValue = brandsInState?.value?.toJS?.() || [];
            return brandValue.map(b => b.code);
        }
    };

    const brandsSelectedRef = useRef(getInitialBrands());

    // Local function to keep track of the selected brands
    const onBrandChange = (selectedItems) => {
        // Check if the value received is empty
        if (!selectedItems || selectedItems.length === 0) {
            // If empty, empty the ref
            brandsSelectedRef.current = [];
        } else {
            // Otherwise, update ref with new items list
            brandsSelectedRef.current = [...selectedItems];
        }
        props.handleBrandsChange(brandsSelectedRef.current)

        //console.warn('selected brand from FormExportPanel', selectedItems)
    }
    //console.warn('brandsSelectedRef from FormExportPanel', brandsSelectedRef.current)

    return (
        <Form
            onSubmit={props.onSubmit}
            validate={(values) => validate(values, props.exportType)}
            initialValues={props.initialFormValues}
            render={({
                         handleSubmit,
                         pristine,
                         hasValidationErrors,
                         submitError,
                         submitting,
                         errors,
                         touched,
                         form,
                         ...rest
                     }) => {
                if (form) {
                    props.formRef.current = form;
                }

                return (
                    <form
                        onSubmit={handleSubmit}
                        className="form-vertical text-primary"
                    >
                        <div className="grid grid-cols-2 gap-2 mb-2 mt-4">
                            {props.exportType === 'Marca' && (
                                <div className="col-span-2 xl:col-span-1">
                                    <Field
                                        name="brands"
                                        component={SelectBrandsMultipleField}
                                        valueKey="code"
                                        onCustomChange={(value) => onBrandChange(value)}
                                        storedValue={brandsSelectedRef.current}
                                    />
                                </div>
                            )}
                            {props.exportType === 'Collezione' && (
                                <div className="col-span-2 xl:col-span-1">
                                    <Field
                                        name="collection"
                                        component={SelectField}
                                        options={props.collections}
                                        layout="vertical"
                                        label="Seleziona una lista"
                                        placeholder="Seleziona una lista"
                                        className="form-input input-lg"
                                        onCustomChange={(item) => props.handleCollectionChange(item)}
                                    />
                                </div>
                            )}
                            <div
                                className={
                                    props.exportType !== 'Selezione'
                                        ? 'col-span-2 xl:col-span-1'
                                        : 'col-span-2'
                                }
                            >
                                <Field
                                    name="exchange_format"
                                    component={SelectField}
                                    options={props.availableExchangeFormats.map((e) => {
                                        let label = e.name

                                        if (e.multimarca) {
                                            label += ' (multimarca)';
                                        }
                                        // Disable the option if brandsChoosedRef > 1 and e.multimarca is false
                                        let isDisabled = props.brandsChoosed > 1 && e.multimarca === false

                                        return {
                                            value: e.code,
                                            label,
                                            disabled: isDisabled,
                                        }
                                    })}
                                    layout="vertical"
                                    placeholder={i18nMark('select exchange format')}
                                    className="form-input input-lg"
                                    disabled={
                                        props.exportType === 'Selezione' &&
                                        !props.isAnyFilterActive
                                    }
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <Field
                                name="notes"
                                component={TextareaField}
                                layout="vertical"
                                placeholder={i18nMark('note')}
                                className="form-input input-lg"
                                disabled={
                                    props.exportType === 'Selezione' &&
                                    !props.isAnyFilterActive
                                }
                            />
                        </div>
                        <SubmitButton
                            submitting={submitting}
                            disabled={
                                pristine ||
                                (props.exportType === 'Selezione' &&
                                    !props.isAnyFilterActive)
                            }
                        >
                            <Trans id="request" />
                        </SubmitButton>
                    </form>
                );
            }}
        />

    )
}

export default FormExportPanel